/**
 * Preferencias Explorer: auto-pin series .Ref en descarga (localStorage).
 */
export const EXPLORER_AUTO_REF_PIN_KEY = 'udv.explorerAutoRefPin'
export const EXPLORER_AUTO_REF_PIN_EVENT = 'udv-explorer-auto-ref-pin-changed'

/**
 * Default según perfil.
 * @param {{ portalProfile?: boolean }} [opts]
 * @returns {boolean}
 */
export function defaultExplorerAutoRefPin(opts = {}) {
  if (opts.portalProfile) return false
  return true
}

/**
 * @param {{ portalProfile?: boolean }} [opts]
 * @returns {boolean}
 */
export function getExplorerAutoRefPin(opts = {}) {
  try {
    const raw = localStorage.getItem(EXPLORER_AUTO_REF_PIN_KEY)
    if (raw === '0' || raw === 'false') return false
    if (raw === '1' || raw === 'true') return true
  } catch (e) {
    /* ignore */
  }
  return defaultExplorerAutoRefPin(opts)
}

/**
 * @param {boolean} enabled
 * @returns {boolean}
 */
export function setExplorerAutoRefPin(enabled) {
  const v = !!enabled
  try {
    localStorage.setItem(EXPLORER_AUTO_REF_PIN_KEY, v ? '1' : '0')
  } catch (e) {
    /* ignore */
  }
  try {
    window.dispatchEvent(
      new CustomEvent(EXPLORER_AUTO_REF_PIN_EVENT, { detail: { enabled: v } })
    )
  } catch (e) {
    /* ignore */
  }
  return v
}

export const MANUAL_PIN_MAX = 2
